export const resolveApiBaseUrl = (
  configuredBaseUrl = process.env.REACT_APP_API_URL || '',
  currentLocation = typeof window !== 'undefined' ? window.location : null,
) => {
  const trimmed = String(configuredBaseUrl || '').trim();
  if (!trimmed) {
    return '';
  }

  if (!currentLocation) {
    return trimmed.replace(/\/$/, '');
  }

  try {
    const resolved = new URL(trimmed, currentLocation.origin);

    if (currentLocation.protocol === 'https:' && resolved.protocol === 'http:') {
      resolved.protocol = 'https:';
    }

    if (resolved.host === currentLocation.host) {
      const relativePath = resolved.pathname === '/' ? '' : resolved.pathname.replace(/\/$/, '');
      return `${relativePath}${resolved.search}${resolved.hash}`;
    }

    return resolved.toString().replace(/\/$/, '');
  } catch {
    return trimmed.replace(/\/$/, '');
  }
};

export const getApiBaseUrl = () => resolveApiBaseUrl();
